export default __webpack_public_path__ + "a307e08960f618b015235af78c650874.woff2";